import { render } from "./PackageZone.vue?vue&type=template&id=4dec9171&scoped=true"
import script from "./PackageZone.vue?vue&type=script&lang=js"
export * from "./PackageZone.vue?vue&type=script&lang=js"

import "./PackageZone.vue?vue&type=style&index=0&id=4dec9171&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dec9171"]])

export default __exports__